import React, {FC, useEffect, useState} from "react"
import styled from "styled-components"

import {Body} from "@irati/ui/src/Typography"
import IconButton from "@irati/ui/src/Button/IconButton"

import Flex from "../Flex"
import Icon, {IconTypes} from "../Icon"

const AUTO_DISMISS_TIME = 5000

export enum ToastBannerTypes {
  SUCCESS = "Success"
}

interface Props {
  text: string,
  onDismiss?: () => void,
  type?: ToastBannerTypes
}

const StyledFlex = styled(Flex)`
  background-color: ${({theme}) => theme.colors.greys.lightest};
`

const ToastIcons = {
  [ToastBannerTypes.SUCCESS]: IconTypes.circleTickFill
}

const ToastBanner: FC<Props> = ({text, onDismiss, type = ToastBannerTypes.SUCCESS}) => {
  const [show, setShow] = useState(true)

  useEffect(() => {
    setTimeout(dismissBanner, AUTO_DISMISS_TIME)
  }, [])

  const dismissBanner = () => {
    setShow(false)
    /* eslint-disable-next-line no-unused-expressions */
    onDismiss?.()
  }

  if (!show) {
    return null
  }

  return (
    <StyledFlex justifyContent="space-between" alignItems="center" padding={2} marginBottom={2}>
      <Flex alignItems="center">
        <Icon icon={ToastIcons[type]} marginRight />
        <Body>{text}</Body>
      </Flex>
      <IconButton onClick={dismissBanner} icon={IconTypes.close} />
    </StyledFlex>
  )
}

export default ToastBanner
